import { Effect } from "effect"
import type {
  FontSystemInputs,
  FontSystemValidationResult,
} from "./types"
import { validateAstroFontConfig } from "./validate-astro-font-config"
import { validateFontManifest } from "./validate-font-manifest"
import { validateLayoutFontInjection } from "./validate-layout-font-injection"
import { validateLegacyFontImport } from "./validate-legacy-font-import"

export const validateFontSystem = (
  inputs: FontSystemInputs,
): Effect.Effect<FontSystemValidationResult> =>
  Effect.sync(() => {
    const manifestResult = validateFontManifest(inputs.fontManifestJson)
    const astroIssues = validateAstroFontConfig(inputs.astroConfig)
    const layoutIssues = validateLayoutFontInjection(inputs.layoutAstro)
    const globalCssIssues = validateLegacyFontImport(inputs.globalCss)

    const issues = [
      ...manifestResult.issues,
      ...astroIssues,
      ...layoutIssues,
      ...globalCssIssues,
    ]

    return {
      isValid: issues.length === 0,
      manifest: manifestResult.manifest,
      issues,
      summary: issues.length === 0
        ? "Font system valid — manifest, Astro config, layout, and global CSS match the required pattern."
        : `Font system invalid: ${issues.length} issue(s) found.`,
    }
  })
